var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        [
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Products" } },
            [_c("product-page")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Category" } },
            [_c("category-product")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }